"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;

var react_1 = __importDefault(require("react"));

exports.SVG = function () {
  return react_1["default"].createElement("svg", {
    viewBox: "0 0 20 20",
    fill: "none"
  }, react_1["default"].createElement("path", {
    d: "M17.5168 8.586C18.1618 9.372 18.1618 10.627 17.5168 11.413C16.0598 13.187 13.2408 16 9.99975 16C6.75975 16 3.94075 13.187 2.48375 11.413C1.83875 10.627 1.83875 9.372 2.48375 8.586C3.94075 6.813 6.75975 4 9.99975 4C13.2408 4 16.0598 6.813 17.5168 8.586ZM13.0001 9.9996C13.0001 8.3426 11.6571 6.9996 10.0001 6.9996C8.34315 6.9996 7.00015 8.3426 7.00015 9.9996C7.00015 11.6566 8.34315 12.9996 10.0001 12.9996C11.6571 12.9996 13.0001 11.6566 13.0001 9.9996ZM11.7774 9.9996C11.7774 10.9816 10.9815 11.7776 10.0005 11.7776C9.01845 11.7776 8.22245 10.9816 8.22245 9.9996C8.22245 9.0176 9.01845 8.2216 10.0005 8.2216C10.9815 8.2216 11.7774 9.0176 11.7774 9.9996Z",
    fill: "#727B7F"
  }));
};